import React from 'react';
import { get } from 'lodash-es';
import classNames from 'classnames';
import { formatPriceKString } from 'site-modules/shared/utils/price-utils';
import { getUsedSliderPaymentsData } from 'site-modules/shared/components/car-buying/offer-type-table/offer-type-table-chart-utils';
import { InventoryEntities } from 'client/data/models/inventory';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { FAIR_DEAL, GOOD_DEAL, GREAT_DEAL, HIGH_DEAL } from 'site-modules/shared/components/deal/deal-constants';
import { getPricePosition } from 'site-modules/shared/utils/inventory/price-graph';

import './price-rating-graphic.scss';

const PIN_WIDTH = 40;

export function PriceRatingGraphic({ vehicle = {} }) {
  const { lowerPayment, upperPayment } = getUsedSliderPaymentsData({ vehicle });
  const price = get(vehicle, 'prices.advertisedPrice', 0);
  const { maxGreatPrice, maxGoodPrice, maxFairPrice } = get(vehicle, 'computedDisplayInfo.priceValidation', {});
  const dealType = get(vehicle, 'computedDisplayInfo.priceValidation.dealType', '');
  const deals = [
    {
      label: GREAT_DEAL,
      minPrice: lowerPayment,
      maxPrice: maxGreatPrice,
      classnames: 'deal-great',
      pinSrc: 'price-rating-graphic/price-rating-pin-great.svg',
    },
    {
      label: GOOD_DEAL,
      minPrice: maxGreatPrice,
      maxPrice: maxGoodPrice,
      classnames: 'deal-good',
      pinSrc: 'price-rating-graphic/price-rating-pin-good.svg',
    },
    {
      label: FAIR_DEAL,
      minPrice: maxGoodPrice,
      maxPrice: maxFairPrice,
      classnames: 'deal-fair',
      pinSrc: 'price-rating-graphic/price-rating-pin-fair.svg',
    },
    {
      label: HIGH_DEAL,
      minPrice: maxFairPrice,
      maxPrice: upperPayment,
      classnames: 'deal-high',
      pinSrc: 'price-rating-graphic/price-rating-pin-high.svg',
    },
  ];

  const activeDeal = deals.find(({ label }) => label === dealType);
  const pricePosition = getPricePosition({ price, ...activeDeal });

  return (
    <div className="price-rating-graphic pos-r mt-3">
      <div className="d-flex justify-content-between size-12 text-cool-gray-40 mb-0_25">
        <span>{formatPriceKString(lowerPayment)}</span>
        <span>{formatPriceKString(upperPayment)}</span>
      </div>
      <div className="pos-r">
        <ul className="p-0 m-0 list-unstyled d-flex pb-1_25">
          {deals.map(({ classnames, label, pinSrc }) => {
            const isActiveDeal = dealType === label;
            return (
              <li
                key={label}
                className={classNames(classnames, 'rounded-12 pos-r size-12 fw-medium', {
                  'active text-cool-gray-30': isActiveDeal,
                  'text-cool-gray-40': !isActiveDeal,
                })}
              >
                <span className="deal-label pos-a left-0 right-0 text-center">{label}</span>
                {isActiveDeal && (
                  <div className="pos-a" style={{ left: `${pricePosition}%` }}>
                    <div className="active-dot pos-a bg-white" />
                    <div className="active-pin pos-a">
                      <img src={getStaticImageUrl(pinSrc)} alt="deal type pin" className="pin-icon" width={PIN_WIDTH} />
                    </div>
                  </div>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

PriceRatingGraphic.propTypes = {
  vehicle: InventoryEntities.InventoryVin,
};
